/** Clamps a middle value within a range of values between a defined minimum bound and a maximum bound.
    The function takes three parameters: a minimum value, a preferred value, and a maximum allowed value. */
export function clamp(
  min: number,
  val: number | undefined | null,
  max: number,
) {
  return Math.max(Math.min(val ?? 0, max), min);
}
